import React from "react";
import { Card } from "antd";
import AnimatedCounter from "./AnimatedCounter";

/**
 * icon + label + big animated number, with a colored accent bar on the left.
 * Used to rebuild stat tile rows (e.g. Dashboard summary) consistently.
 */
// `display` renders as-is instead of animating `value` through
// AnimatedCounter — needed for values AnimatedCounter can't represent
// faithfully (it rounds to whole numbers via Math.round, so a decimal
// amount like a USD total with cents would silently lose its cents).
const StatCard = ({ icon, label, value, display, color = "var(--i-ems-primary)", onClick }) => (
  <Card
    className={onClick ? "i-ems-stat-card i-ems-clickable-card" : "i-ems-stat-card"}
    bodyStyle={{ padding: 0 }}
    onClick={onClick}
    role={onClick ? "button" : undefined}
    tabIndex={onClick ? 0 : undefined}
  >
    <span className="i-ems-stat-accent" style={{ background: color }} />
    <div className="ant-card-body" style={{ display: "flex", alignItems: "center", gap: 10, padding: "14px 16px" }}>
      {icon ? (
        <div className="i-ems-stat-icon" style={{ background: `${color}1A`, color }}>
          {icon}
        </div>
      ) : null}
      <div style={{ minWidth: 0, flex: 1 }}>
        <div className="i-ems-stat-label">{label}</div>
        <div className="i-ems-stat-value">{display !== undefined ? display : <AnimatedCounter value={value} />}</div>
      </div>
    </div>
  </Card>
);

export default StatCard;
